import { render, staticRenderFns } from "./df-header-mobile.vue?vue&type=template&id=c5be945e"
import script from "./df-header-mobile.ts?vue&type=script&lang=js&external"
export * from "./df-header-mobile.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports